var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookOpen01New(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 18.6667 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M9.33334 16L9.24996 15.8749C8.67109 15.0066 8.38165 14.5725 7.99925 14.2582C7.66072 13.9799 7.27064 13.7712 6.85134 13.6438C6.37771 13.5 5.85593 13.5 4.81236 13.5H3.66667C2.73325 13.5 2.26654 13.5 1.91002 13.3183C1.59641 13.1586 1.34145 12.9036 1.18166 12.59C1 12.2335 1 11.7668 1 10.8333V3.66667C1 2.73325 1 2.26654 1.18166 1.91002C1.34145 1.59641 1.59641 1.34145 1.91002 1.18166C2.26654 1 2.73325 1 3.66667 1H4C5.86684 1 6.80026 1 7.5133 1.36331C8.14051 1.68289 8.65045 2.19283 8.97002 2.82003C9.33334 3.53307 9.33334 4.46649 9.33334 6.33334M9.33334 16V6.33334M9.33334 16L9.41671 15.8749C9.99558 15.0066 10.285 14.5725 10.6674 14.2582C11.006 13.9799 11.396 13.7712 11.8153 13.6438C12.289 13.5 12.8107 13.5 13.8543 13.5H15C15.9334 13.5 16.4001 13.5 16.7567 13.3183C17.0703 13.1586 17.3252 12.9036 17.485 12.59C17.6667 12.2335 17.6667 11.7668 17.6667 10.8333V3.66667C17.6667 2.73325 17.6667 2.26654 17.485 1.91002C17.3252 1.59641 17.0703 1.34145 16.7567 1.18166C16.4001 1 15.9334 1 15 1H14.6667C12.7998 1 11.8664 1 11.1534 1.36331C10.5262 1.68289 10.0162 2.19283 9.69665 2.82003C9.33334 3.53307 9.33334 4.46649 9.33334 6.33334",
    stroke: "var(--stroke-0, black)",
    strokeWidth: 1.56,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookOpen01New);
export default __webpack_public_path__ + "static/media/book-open-01-new.e3a1a67f80ba2ed20354add36cba6358.svg";
export { ForwardRef as ReactComponent };